import React from 'react';
import { get, isEmpty } from 'lodash';
import { listWM, readWM, custom } from 'utils/Api';
import * as types from 'constants/ActionTypes';
import { addNotification } from 'reapop';
import { FormattedMessage } from 'react-intl';

/* EMPLOYEE MASTER */

function requestEmployeeMaster() {
  return {
    type: types.REQUEST_EMPLOYEE_MASTER,
    employeeMaster: {},
    employeeMasterLoaded: false,
    sentAt: Date.now(),
    masterError: null,
  };
}

function requestEmployeeMasterFailure(error) {
  return {
    type: types.REQUEST_EMPLOYEE_MASTER_FAILURE,
    employeeMaster: {},
    employeeMasterLoaded: true,
    receivedAt: Date.now(),
    masterError: error,
  };
}

function requestEmployeeMasterSuccess(employeeMaster) {
  return {
    type: types.REQUEST_EMPLOYEE_MASTER_SUCCESS,
    employeeMasterLoaded: true,
    receivedAt: Date.now(),
    employeeMaster,
    masterError: null,
  };
}

export const fetchEmployeeMaster = () => async (dispatch, getState) => {
  try {
    dispatch(requestEmployeeMaster());
    const { loginReducer: { user: { EmployeeMasterID, DefaultEmployeeDetailID, token } } } = getState();
    const config = {
      entity: 'EmployeeMaster',
      entityID: EmployeeMasterID,
      headers: { Authorization: `Bearer ${token}` },
    };
    const configApi2 = {
      headers: { Authorization: `Bearer ${token}` },
      url: `/kjarni/api/v2/EmployeeDetails/${DefaultEmployeeDetailID}`,
    };
    const { data } = await readWM(config);
    const { data: { IdentificationCard, EmployeeDetailID } } = await custom(configApi2);
    dispatch(requestEmployeeMasterSuccess({ ...data, IdentificationCard, EmployeeDetailID }));
  } catch (error) {
    dispatch(requestEmployeeMasterFailure(error));
  }
};

/* EMPLOYEE DETAIL ORG */

function requestEmployeeDetailOrg() {
  return {
    type: types.REQUEST_EMPLOYEE_DETAIL_ORG,
    employeeDetailOrgList: [],
    employeeDetailOrgListLoaded: false,
    sentAt: Date.now(),
    detailError: null,
  };
}

function requestEmployeeDetailOrgFailure(error) {
  return {
    type: types.REQUEST_EMPLOYEE_DETAIL_ORG_FAILURE,
    employeeDetailOrgList: [],
    employeeDetailOrgListLoaded: true,
    receivedAt: Date.now(),
    detailError: error,
  };
}

function requestEmployeeDetailOrgSuccess(employeeDetailOrgList) {
  return {
    type: types.REQUEST_EMPLOYEE_DETAIL_ORG_SUCCESS,
    employeeDetailOrgListLoaded: true,
    receivedAt: Date.now(),
    employeeDetailOrgList,
    detailError: null,
  };
}

export const fetchEmployeeDetailOrg = () => async (dispatch, getState) => {
  // return (dispatch, getState) => {
  dispatch(requestEmployeeDetailOrg());
  const { loginReducer: { user: { EmployeeMasterID, token } } } = getState();
  const now = new Date().toISOString();
  const fetchConfig = {
    entity: 'EmployeeDetailOrg',
    headers: { Authorization: `Bearer ${token}` },
    params: {
      $filter: `Entity/EmployeeDetailID ge ${EmployeeMasterID}1 and Entity/EmployeeDetailID le ${EmployeeMasterID}9 and (Entity/EmployeeStatus eq '0' or (Entity/EmployeeStatus ge '4'  and Entity/EmployeeStatus le '7')) and Entity/Begda le datetime'${now}' and Entity/Endda ge datetime'${now}'`,
    },
  };

  listWM(fetchConfig)
    .then(({ data }) => dispatch(requestEmployeeDetailOrgSuccess(data)))
    .catch(error => dispatch(requestEmployeeDetailOrgFailure(error)));
};
// }

export function fetchProfileIfNeeded() {
  return (dispatch, getState) => {
    if (isEmpty(getState().profileReducer.employeeMaster)) {
      dispatch(fetchEmployeeMaster());
    }
    const orgs = getState().profileReducer.employeeDetailOrgList;
    if (!orgs || !orgs.length) {
      dispatch(fetchEmployeeDetailOrg());
    }
  };
}

export function fetchOrgsIfNeeded() {
  return (dispatch, getState) => {
    const orgs = getState().profileReducer.employeeDetailOrgList;
    if (!orgs || !orgs.length) {
      dispatch(fetchEmployeeDetailOrg());
    }
  };
}

/* EMPLOYEE DETAILS */

function patchRequest() {
  return {
    type: types.PATCH_EMPLOYEE_DETAIL_IDENTIFICATION_REQUEST,
    sentAt: Date.now(),
  };
}

function patchSuccess(entry, entryId) {
  return {
    type: types.PATCH_EMPLOYEE_DETAIL_IDENTIFICATION_SUCCESS,
    receivedAt: Date.now(),
    entry,
    entryId,
  };
}

function patchFailure(error) {
  return {
    type: types.PATCH_EMPLOYEE_DETAIL_IDENTIFICATION_FAILURE,
    receivedAt: Date.now(),
    error,
  };
}

export function patchIdentificationCard(entry, entryId) {
  return async (dispatch) => {
    try {
      dispatch(patchRequest());
      const res = await custom({
        url: `/kjarni/api/v2/EmployeeDetails(${entryId})`,
        method: 'PATCH',
        data: entry,
      });

      const data = get(res, 'data', {});
      dispatch(patchSuccess(data, entryId));

    } catch (error) {
      dispatch(patchFailure(error));
      dispatch(addNotification({
        title: <FormattedMessage id="notification.error.title" />,
        message: get(error, 'message'),
        status: 'error',
        dismissible: true,
        dismissAfter: 3000,
      }));
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/profile.js